import { minutesOfDayInTz } from "./timeGrid"

export interface NearestSlotResult {
  slot: string | null
  hint: { tappedMin: number; chosenMin: number } | null
}

export function resolveStartSlot(
  slots: string[],
  tz: string,
  targetMin: number | undefined,
): NearestSlotResult {
  if (slots.length === 0) return { slot: null, hint: null }
  if (targetMin === undefined) return { slot: null, hint: null }

  const withMin = slots.map((s) => ({ slot: s, min: minutesOfDayInTz(s, tz) }))

  // Exact match
  const exact = withMin.find((x) => x.min === targetMin)
  if (exact) return { slot: exact.slot, hint: null }

  // Nearest (min |Δ|, tie → later)
  let best = withMin[0]
  for (const x of withMin) {
    const diff = Math.abs(x.min - targetMin)
    const bestDiff = Math.abs(best.min - targetMin)
    if (diff < bestDiff || (diff === bestDiff && x.min > best.min)) {
      best = x
    }
  }

  return {
    slot: best.slot,
    hint: { tappedMin: targetMin, chosenMin: best.min },
  }
}
